var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React from 'react';
import Rnd from 'react-rnd';
import { Button } from '../elements';
var Zone = /** @class */ (function (_super) {
    __extends(Zone, _super);
    function Zone() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Zone.prototype.render = function () {
        var _a = this.props, seatArea = _a.seatArea, index = _a.index, seatAreaSelected = _a.seatAreaSelected, style = _a.style, onResizeStop = _a.onResizeStop, onDragStop = _a.onDragStop, onClickEdit = _a.onClickEdit, children = _a.children;
        var selected = seatAreaSelected && seatArea.name === seatAreaSelected.name;
        return (React.createElement(Rnd, { bounds: 'parent', key: seatArea.id, style: {
                borderRadius: selected ? '10px' : '3px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                border: selected ? '10px solid blue' : '1px solid #ddd',
                background: this.props.seatArea.backgroundColor,
                color: this.props.seatArea.fontColor
            }, default: {
                x: seatArea.position.x,
                y: seatArea.position.y,
                width: seatArea.size.width,
                height: seatArea.size.height
            }, onResizeStop: function (e, dir, elementRef, delta, position) {
                onResizeStop(e, dir, elementRef, delta, position, index);
            }, onDragStop: function (e, data) { return onDragStop(e, data, index); } },
            seatArea.name,
            React.createElement(Button, { key: 'button-' + seatArea.id, style: { position: 'absolute', top: 0, right: 0 }, onClick: function () { onClickEdit(seatArea); } }, seatAreaSelected && seatAreaSelected.name === seatArea.name ? 'cerrar' : 'editar'),
            children));
    };
    return Zone;
}(React.Component));
export default Zone;



//////////////////
// WEBPACK FOOTER
// ./src/components/Zone.tsx
// module id = 1396
// module chunks = 0